// src/pages/RoomDetailPage/RoomDetailPage.jsx

import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { rooms } from '../../data/roomsData';
import { FaUsers, FaUtensils } from 'react-icons/fa';
import { FeatureIcon, RoomHeroGallery } from '../../components';
import './RoomDetailPage.css';

// --- NOVOS TEXTOS OTIMIZADOS PARA SEO E PARA OS QUARTOS DO PLAZA ---
const roomDetailsContent = {
  Duplo: {
    title: "Conforto e Elegância para Sua Estadia no Centro",
    description: "Nosso Quarto Duplo no Alzira Plaza Hotel é o refúgio ideal para casais ou viajantes solo em busca de conforto e praticidade. Localizado no coração de São Lourenço, a apenas 100 metros do Parque das Águas, oferece uma experiência tranquila e bem equipada. Desfrute de um ambiente climatizado com opções de cama de casal ou duas de solteiro, perfeito para relaxar após um dia explorando as belezas do Circuito das Águas."
  },
  Triplo: {
    title: "Espaço e Comodidade para Famílias Pequenas",
    description: "O Quarto Triplo do Alzira Plaza foi pensado para oferecer o máximo de conforto a famílias pequenas ou grupos de amigos. Com acomodação para até três pessoas, é a escolha ideal para quem busca versatilidade e bem-estar no centro de São Lourenço. Composto por uma cama de casal e uma de solteiro (ou três de solteiro), este quarto proporciona o descanso merecido e acesso fácil às atrações da cidade."
  },
  Quádruplo: {
    title: "Acomodação Perfeita para Famílias Grandes",
    description: "Projetado para garantir o conforto de até quatro pessoas, nosso Quarto Quádruplo é a solução ideal para famílias ou grupos maiores que visitam São Lourenço. Com um layout inteligente e opções de camas flexíveis, este quarto oferece o espaço necessário para que todos desfrutem de uma estadia agradável e repleta de comodidades, tudo isso com a localização privilegiada do Alzira Plaza."
  }
};

const RoomDetailPage = () => {
  const { roomType } = useParams();
  // Garante que o roomType corresponda ao 'type' do objeto no roomsData (ex: "Duplo", "Triplo")
  const room = rooms.find(r => r.type.toLowerCase() === roomType);

  if (!room) {
    return (
      <div className="room-not-found">
        <h2>Acomodação não encontrada</h2>
        <Link to="/">Voltar para a página inicial</Link>
      </div>
    );
  }

  // Acessa o conteúdo dinamicamente usando room.type
  const content = roomDetailsContent[room.type] || {};

  return (
    <div className="room-detail-container">
      <div className="section-header">
        <span className="section-eyebrow">{room.type}</span>
        <h1 className="section-title">{room.title}</h1>
      </div>
      <RoomHeroGallery images={room.images} title={room.title} />

      <div className="room-info-layout">
        <div className="room-description-column">
          <h1>{content.title}</h1>
          <p>{content.description}</p>
        </div>

        <div className="room-summary-column">
          <div className="summary-card">
            <div className="summary-item">
              <FaUsers className="summary-icon" />
              <div>
                <strong>Capacidade</strong>
                <span>{room.capacity}</span>
              </div>
            </div>
            <div className="summary-item">
              <FeatureIcon iconName="FaBed" className="summary-icon" />
              <div>
                <strong>Tipo de Cama</strong>
                <span>{room.features.find(f => f.icon === 'FaBed')?.text}</span>
              </div>
            </div>
            <div className="summary-item">
              <FaUtensils className="summary-icon" />
              <div>
                <strong>Refeições</strong>
                <span>Café da manhã incluso ou Pensão Completa* <br />(*Almoço e Jantar serão realizados em um dos hotéis da Rede Alzira)</span>
              </div>
            </div>

            {/* --- NÚMERO DE WHATSAPP ATUALIZADO --- */}
            <a href="https://wa.me/+5535988179138" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              Fazer Reserva
            </a>
          </div>
        </div>
      </div>

      <div className="room-amenities-section">
        <h2 className="amenities-title">Todas as Comodidades</h2>
        <div className="amenities-grid">
          {room.features.map((feature, index) => (
            <div key={index} className="amenity-item">
              <FeatureIcon iconName={feature.icon} />
              <span>{feature.text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="final-cta-section">
        <h2>Pronto para Viver esta Experiência?</h2>
        <p>Garanta sua data em nosso hotel, no coração de São Lourenço.</p>
        {/* --- NÚMERO DE WHATSAPP ATUALIZADO --- */}
        <a href="https://wa.me/+5535988179138" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
          Fazer Reserva Agora
        </a>
      </div>

    </div>
  );
};

export default RoomDetailPage;